import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'AppConfig'

export const AppCustomDataEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetCustomAppDataBO"),

    new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetGeneralMappingConfig"),

    new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("SaveGeneralMappingConfig")

]